import {makeStyles} from '@material-ui/core/styles';

export const CreatePaymentStyles = makeStyles((theme) => ({
  formError: {
    color: "#f44336",
  },
  button: {
    margin: theme.spacing(2),
    width: "200px",
    height: "40px",
    borderRadius: "4px",
    textTransform: 'none',
  },
  buttonFile: {
    width: "256px"
  },
  inputCustom: {
    "& .MuiOutlinedInput-root": {
      height: "32px",
    },
    "& .MuiInputBase-input": {
      fontSize: 16,
      fontFamily: [
        'Roboto',
        'Arial'
      ].join(','),
    }
  },
  ctnInner: {
    fontFamily: [
      'Roboto',
      'Arial'
    ].join(','),
    fontWeight: "bold",
    color: "#2F3A4A"
  },
  optButton: {
    "& .MuiFormControlLabel-label": {
      fontSize: 16
    }
  },
  grdItem: {
    marginTop: 5,
  },
  alert: {
    width: "100%",
    fontSize: "12px !important",
    margin: "0px 12px",
  },
  ctnUploadFile: {
    backgroundColor: "white",
    borderColor: 'solid #BDBDBD'
  },
  buttonUpload: {
    margin: theme.spacing(2),
    width: "200px",
    height: "40px",
    borderRadius: "4px",
    textTransform: 'none',
    backgroundColor: 'black',
    color: 'white',
    "&:hover": {
      backgroundColor: "black !important",
    }
  },
  blockInputFile: {
    width: '100%'
  },
  inputFile: {
    border: 'none'
  }
}));
